import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const MobileBox = styled.div`
   position: relative;
   z-index: 10;
   top:-5px;
   transform: scale(1.5);
`;

const PcBox = styled(MobileBox)`
    transform: scale(1.7);
`;

const WOFWrapperBox = styledByDevice(PcBox, MobileBox);

export default WOFWrapperBox;